import React, { useEffect, useState } from "react";
import { useLocation, withRouter } from "react-router";
import { vinicaState } from "./VinicaContext";
import FormnavBar from "../../../components/common/wizard_navbar";
import $ from "jquery";
import WizardLeft from "../../../components/common/wizard_left";
const queryString = require("query-string");

const InsertFormVinica = (props) => {
    const [state, setState] = useState();
    const [parsed, setParsed] = useState();
    const { search } = useLocation();
    const handleChange = () => {};
    const handleSubmit = () => {};

    const updatesel_nev = (sel_nev) => {
        this.setState({
            sel_nev,
        });
        if ($("#" + sel_nev).length) {
            $("html, body").animate(
                {
                    scrollTop: $("#" + sel_nev).offset().top - 95, //#DIV_ID is an example. Use the id of your destination on the page
                },
                "slow"
            );
        }
    };

    useEffect(() => {
        const parsed = queryString.parse(search);
        setParsed(parsed);
    }, []);
    return (
        <>
            <vinicaState.Provider value={(state, handleChange)}>
                <FormnavBar
                    isInEdit={parsed && parsed.id ? true : false}
                    to="/instalacaovinica"
                    noCancelarEVoltarBtn={true}
                    showDelete={true}
                    handleSubmit={(data, url) => handleSubmit(data, url)}
                    type="instalacoesvinicas"
                    headName={"Inserir Instalação Vínica"}
                />
                <WizardLeft
                        date={new Date()}
                        id={null}
                        updatesel_nev={(sel_nev) => this.updatesel_nev(sel_nev)}
                        sel_nev={this.state.sel_nev}
                        type="instalaçõesinsert"
                    />
            </vinicaState.Provider>
        </>
    );
};

export default withRouter(InsertFormVinica);
